(function () {
  const DURATION = 220;

  function getPanelFromButton(btn) {
    const row = btn.closest(".mm-row");
    if (!row) return null;

    const panel = row.nextElementSibling;
    if (panel && panel.classList && panel.classList.contains("mm-children")) {
      return panel;
    }
    return null;
  }

  function expand(panel) {
    panel.removeAttribute("hidden");
    panel.hidden = false;

    panel.style.display = "block";
    panel.style.overflow = "hidden";
    panel.style.height = "0px";
    panel.getBoundingClientRect();

    const target = panel.scrollHeight;
    panel.style.transition = `height ${DURATION}ms ease`;
    panel.style.height = target + "px";

    const onEnd = (e) => {
      if (e.propertyName !== "height") return;
      panel.style.transition = "";
      panel.style.height = "auto";
      panel.style.overflow = "";
      panel.removeEventListener("transitionend", onEnd);
    };
    panel.addEventListener("transitionend", onEnd);
  }

  function collapse(panel) {
    panel.style.display = "block";
    panel.style.overflow = "hidden";
    panel.style.height = panel.scrollHeight + "px";
    panel.getBoundingClientRect();

    panel.style.transition = `height ${DURATION}ms ease`;
    panel.style.height = "0px";

    const onEnd = (e) => {
      if (e.propertyName !== "height") return;
      panel.style.transition = "";
      panel.style.height = "";
      panel.style.overflow = "";
      panel.style.display = "";
      panel.setAttribute("hidden", "");
      panel.hidden = true;
      panel.removeEventListener("transitionend", onEnd);
    };
    panel.addEventListener("transitionend", onEnd);
  }

  function toggle(btn, panel) {
    const isOpen = btn.getAttribute("aria-expanded") === "true";
    const nextOpen = !isOpen;

    btn.setAttribute("aria-expanded", nextOpen ? "true" : "false");

    if (nextOpen) expand(panel);
    else collapse(panel);
  }

  document.addEventListener(
    "click",
    function (e) {
      const btn = e.target.closest("[data-mm-toggle]");
      if (!btn) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const panel = getPanelFromButton(btn);
      if (!panel) return;

      toggle(btn, panel);
    },
    true
  );
})();
